"use client";
import React from "react";
import { Box, Heading, Text, Flex } from "@chakra-ui/react";
import { SectionDivider } from "app/components/shared/SectionDivider";
import Image, { StaticImageData } from "next/image";
import { EVE_NG_CLOUD_HOSTED_CARD } from "./components/constants";
import Link from "next/link";

export const CloudHostedCard = (props: {
  content: string[];
  image: StaticImageData;
  title: string;
  subtitle?: string;
  key: number;
  test?: string;
}) => {
  const { key, title, subtitle, image, content, test } = props;
  return (
    <Box
      key={key}
      border={"1px solid #eee"}
      p={4}
      gap={4}
      display={"flex"}
      flexDir={"column"}
      boxShadow={"md"}
      borderRadius={"10px"}
      minWidth={"280px"}
      maxWidth={"25%"}
      marginBottom={"30px"}
      transition={"0.15s"}
      _hover={{
        transform: "scale(1.03)",
        boxShadow: "lg",
      }}
      data-cy={`card-${test}`}
    >
      <Image
        alt={title}
        title={title}
        src={image}
        blurDataURL={
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/epARQABAAA//w6wAAAAAElFTkSuQmCC"
        }
        placeholder="blur"
        style={{
          width: "80%",
          maxWidth: "100%",
          margin: "0 auto",
          height: "150px",
          objectFit: "contain",
          objectPosition: "center",
        }}
      />
      <Heading as={"h3"} textAlign={"center"} fontSize={"2xl"} paddingTop={"4px"}>
        {title}
      </Heading>
      {subtitle && (
        <Heading as={"h3"} textAlign={"center"} fontSize={"lg"} mt={0}>
          {`(${subtitle})`}
        </Heading>
      )}
      {content.map((item, idx) => {
        return (
          <Text key={idx} fontSize={{ base: "md", lg: "lg" }} color={"gray.700"}>
            {item}
          </Text>
        );
      })}
    </Box>
  );
};
const CloudHostedOptions = () => {
  return (
    <>
      <SectionDivider label="EVE-NG Cloud Hosted Platform" />
      <Flex
        flexWrap="wrap"
        justifyContent="center"
        gap={"2%"}
        data-cy="section-eveng-types"
      >
        {EVE_NG_CLOUD_HOSTED_CARD.map((data, index) => {
          return <CloudHostedCard {...data} key={index} />;
        })}
      </Flex>
      <Flex
        justifyContent={"center"}
        direction={{ base: "column", md: "row" }}
        alignItems={"center"}
      >
        <Box style={{ fontSize: "20px", fontWeight: "500" }}>
          How do the EVE-NG versions differ ?{" "}
        </Box>
        <Link
          href={"#eve-ng-comparison-table"}
          style={{
            color: "#4299e1",
            fontSize: "20px",
            fontWeight: "500",
            textDecoration: "underline",
          }}
        >
          Check Here
        </Link>{" "}
      </Flex>
    </>
  );
};
export default CloudHostedOptions;
